import { render } from "./CardInnerGroup.vue?vue&type=template&id=78db8aef"
import script from "./CardInnerGroup.vue?vue&type=script&lang=js"
export * from "./CardInnerGroup.vue?vue&type=script&lang=js"
script.render = render

export default script